<header *ngIf="title">
  <h1>{{title}}</h1>
</header>

<app-study-plan-alerts *ngIf="showPlanAlerts"></app-study-plan-alerts>

<ng-container *ngIf="content" (click)="onBodyClick($event)">
  <div [innerHTML]="content | safeHtml"></div>
</ng-container>
